export function TokenMeter({ session, lastUsage, userUsage }) {
  const total = (session?.input || 0) + (session?.output || 0);
  const userTotal = userUsage ? userUsage.totalTokens : null;
  return (
    <div
      className="cop-token-meter"
      title={
        userTotal != null
          ? `Usuario: ${userTotal.toLocaleString("es-AR")} tok en el periodo`
          : "Consumo de tokens de esta sesión"
      }
    >
      <span className="cop-tm-item">
        <span className="cop-tm-label">Sesión</span>
        <span className="cop-tm-val">{total.toLocaleString("es-AR")} tok</span>
      </span>
      <span className="cop-tm-sep" />
      <span className="cop-tm-item">
        <span className="cop-tm-label">Costo</span>
        <span className="cop-tm-val">US${(session?.cost || 0).toFixed(4)}</span>
      </span>
      {lastUsage && (
        <span className="cop-tm-last">
          último: +{((lastUsage.input_tokens || 0) + (lastUsage.output_tokens || 0)).toLocaleString("es-AR")} tok
        </span>
      )}
    </div>
  );
}
